module.exports = __webpack_public_path__ + "img/public/SiteIcons/photoUpload.svg?c913066b";